import React, { useEffect } from 'react';
import { ReactComponent as CloseIcon } from '../../../Assets/CommonTenant/close.svg';
import styles from './Toast.module.css';


export type ToastType = 'success' | 'error' | 'info';
 
interface ToastProps {
  visible: boolean;
  message: string;
  type?: ToastType;
  onClose: () => void;
  autoHideDuration?: number;
}

const Toast: React.FC<ToastProps> = ({
  visible,
  message,
  type = 'success',
  onClose,
  autoHideDuration = 3000,
}) => {
  useEffect(() => {
    if (visible && autoHideDuration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [visible, autoHideDuration, onClose]);

  if (!visible) return null;

  const isError = type === 'error';

  return (
    <div className={styles.toast}>
      <span className={`${styles.toastText} ${isError ? styles.toastTextError : ''}`}>
        {message}
      </span>
      <button
        className={styles.toastCloseButton}
        onClick={onClose}
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export default Toast;
